import { injectable } from "inversify";
import IRepository from 'data/IRepository';
import { inversifyContainer } from 'infrastructure/ioc/ioc.container';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import { getPaginationDefaults, getQueryParams } from 'features/shared/helpers/queryParams';
import { Contract_Invoices, Requirements_ComplaintType } from 'data/endpoints';
import IComplaintFormService from './IComplaintFormService';
import InvoiceSimplifiedDTO from 'features/invoices/dtos/InvoiceSimplifiedDTO';
import PagedDataResultDTO from 'features/shared/dtos/PagedDataResultDTO';
import ComplaintTypeDTO from '../dtos/ComplaintTypeDTO';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import { InvoiceType } from 'features/invoices/enums/invoiceType';
import { ValueActionType } from 'features/shared/forms/hooks/useForm';

@injectable()
export default class ComplaintFormService implements IComplaintFormService {
  private readonly _complaintsRepository: IRepository<ComplaintTypeDTO>;
  private readonly _invoicesRepository: IRepository<InvoiceSimplifiedDTO>;
    
  constructor() {
    this._complaintsRepository = inversifyContainer.get<IRepository<ComplaintTypeDTO>>(IocTypes.Repository);
    this._invoicesRepository = inversifyContainer.get<IRepository<InvoiceSimplifiedDTO>>(IocTypes.Repository);
  }

  fetchComplaintTypes(contractId: string): Promise<ComplaintTypeDTO[]> {
    return this._complaintsRepository.get({
      url: Requirements_ComplaintType,
      params: getQueryParams("ContractId", contractId),
    });
  }

  fetchInvoices(contractId: string): Promise<PagedDataResultDTO<InvoiceSimplifiedDTO>> {
    let queryParams = getPaginationDefaults(100);
    queryParams.append("InvoiceTypes", InvoiceType.Invoice);

    return this._invoicesRepository.getPagedResult({
      url: Contract_Invoices,
      routeParams: getRouteParams("contractId", contractId),
      params: queryParams
    });
  }

  isFilledValues(values: Record<string, any>, requiredValues: string[]): boolean {
    for (const value of requiredValues) {
      if (!values[value]) {
        return false;
      }
    }

    return true;
  }

  clearFormValues(formKeys: string[], setFormValue: (key: string, value: any, action: ValueActionType) => void): void {
    for (const key of formKeys) {
      setFormValue(key, null, "remove");
    }
  }
}